module.exports = __webpack_public_path__ + "img/logout.9a581d61.svg";